import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, styled, useTheme } from '@streem/ui-react';
import { scrubDataId } from '@streem/toolbox';
export const Transferred = ({ transferred, transferredToTrade, requeued, dataIdPrefix, singleColumn = false, transferredStyles, keyValueStyles, }) => {
    const theme = useTheme();
    const effectiveTitleFontSize = (transferredStyles?.titleFontSize ||
        theme.text.size.mediumLarge);
    const effectiveItemFontSize = (keyValueStyles?.fontSize || theme.text.size.medium);
    const Tile = singleColumn ? TransferredColumnTile : TransferredRowTile;
    return (_jsxs(TransferredWrapper, { children: [_jsx(HeaderWrapper, { titleFontSize: effectiveTitleFontSize, "data-testid": `${dataIdPrefix}-transferred-header`, children: "Call Transferred" }), _jsxs(Tile, { children: [_jsx(TileSegmentForSingleValue, { title: "Call Transferred", value: transferred ? 'Yes' : 'No', fontSize: effectiveItemFontSize, dataIdPrefix: dataIdPrefix }), transferred && (_jsxs(_Fragment, { children: [_jsx(TileSegmentForSingleValue, { title: "Transferred To Trade", value: transferredToTrade, fontSize: effectiveItemFontSize, dataIdPrefix: dataIdPrefix }), _jsx(TileSegmentForSingleValue, { title: "Re-queued", value: requeued ? 'Yes' : 'No', fontSize: effectiveItemFontSize, dataIdPrefix: dataIdPrefix })] }))] })] }));
};
const TileSegmentForSingleValue = ({ title, value, fontSize, dataIdPrefix, }) => {
    return (_jsx(TileSegment, { title: title, fontSize: fontSize, dataIdPrefix: dataIdPrefix, children: _jsx(TileSegmentValue, { fontSize: fontSize, "data-testid": scrubDataId(`${dataIdPrefix}-value-${title}`), children: value ?? null }) }));
};
const TileSegment = ({ children, title, fontSize, dataIdPrefix, }) => {
    return (_jsxs(TileSegmentWrapper, { children: [_jsx(TileSegmentTitle, { fontSize: fontSize, "data-testid": scrubDataId(`${dataIdPrefix}-Transferred-key-${title}`), children: title }), children] }));
};
const TileSegmentTitle = styled.div(props => ({
    marginBottom: '0.5rem',
    fontSize: props.fontSize,
    lineHeight: props.theme.text.lineHeight.medium,
    fontFamily: props.theme.text.headingFontFamily,
    fontWeight: 500,
}));
const TileSegmentWrapper = styled.div({
    minWidth: '30%',
});
const TransferredWrapper = styled.section({
    display: 'flex',
    flexDirection: 'column',
    padding: '.75rem 0 0.4rem 0',
    width: '100%',
});
const HeaderWrapper = styled.div(props => ({
    marginBottom: '.75rem',
    fontFamily: props.theme.text.headingFontFamily,
    fontWeight: 500,
    lineHeight: props.theme.text.lineHeight.medium,
    fontSize: props.titleFontSize,
}));
const TransferredRowTile = styled(Grid)(({ theme }) => ({
    backgroundColor: theme.colors.grey01A50,
    gridTemplateColumns: 'repeat(3, 1fr)',
    padding: '0.5rem 1rem',
    gap: '1rem',
    flex: 1,
}));
const TransferredColumnTile = styled(Grid)(({ theme }) => ({
    backgroundColor: theme.colors.grey01A50,
    gridTemplateColumns: '1fr',
    padding: '0.5rem 1rem',
    gap: '1rem',
}));
const TileSegmentValue = styled.span(props => ({
    fontFamily: props.theme.text.bodyFontFamily,
    fontSize: props.fontSize,
    lineHeight: props.theme.text.lineHeight.medium,
    fontWeight: 400,
}));
//# sourceMappingURL=transferred.js.map